import { ContactDto } from "./contact.dto";
import { LocationDto } from "./location.dto";
export class BaseAccomodationDto {
        constructor(
        public name? : string,
        public contactDto? : ContactDto,
        public locationDto? : LocationDto,
    ) {}
}